// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Modal_wrapper__3e00S","content":"Modal_content__BZbGL"};